export default __webpack_public_path__ + "static/img_768_small2-b19b3b28af50ee53126e6f9c5bf34692.jpg";